import { render, staticRenderFns } from "./tableA.vue?vue&type=template&id=ce1c8520&"
import script from "./tableA.vue?vue&type=script&lang=js&"
export * from "./tableA.vue?vue&type=script&lang=js&"
import style0 from "./tableA.vue?vue&type=style&index=0&id=ce1c8520&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports